<script lang="ts">
	import LucideChevronUp from '~icons/lucide/chevron-up';
	import Button from '$lib/components/Button.svelte';
	const scrollYThreshold = 100;
	let scrollY = $state(0);
	let showBackToTop = $state(false);

	$effect(() => {
		showBackToTop = scrollY > scrollYThreshold;
	});
</script>

<svelte:window bind:scrollY />

{#if showBackToTop}
	<Button
		class="fixed right-6 bottom-[4.5rem] z-50 h-12 w-12 justify-center sm:right-4 sm:bottom-4"
		onclick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
		circle
		transition={{
			fn: 'fade',
			params: { duration: 100 }
		}}
		title="Back to top"
	>
		<LucideChevronUp class="h-6 w-6" />
		<span class="sr-only">Back to top</span>
	</Button>
{/if}
